import { render, staticRenderFns } from "./LayoutShowDetailsTab.vue?vue&type=template&id=bbbc7540"
import script from "./LayoutShowDetailsTab.vue?vue&type=script&lang=ts"
export * from "./LayoutShowDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports